import { Dispatch } from 'redux'
import { getRealEstates } from 'redux/api/Lists'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryGetAllRealEstates() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getRealEstates()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export const useRealEstateActions = () => {
  return {
    tryGetAllRealEstates: useThunkActions(tryGetAllRealEstates)
  }
}
